import { __assign as t } from "./index11.js";
function f(u, c) {
  var a, g = Object.entries((a = c.integrations) !== null && a !== void 0 ? a : {}).reduce(function(i, e) {
    var n, r, o = e[0], s = e[1];
    return typeof s == "object" ? t(t({}, i), (n = {}, n[o] = s, n)) : t(t({}, i), (r = {}, r[o] = {}, r));
  }, {});
  return Object.entries(u.integrations).reduce(function(i, e) {
    var n, r = e[0], o = e[1];
    return t(t({}, i), (n = {}, n[r] = t(t({}, o), g[r]), n));
  }, {});
}
export {
  f as mergedOptions
};
//# sourceMappingURL=index33.js.map
